import axios from "axios";
import { getToken } from "../Utils/UpdateUsersState";

const getFuel = async (to, from, fuel_sensored) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}fuel`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: { to, from, fuel_sensored },
    });
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export { getFuel };
